import React from "react";
import Modal from "react-modal";
import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import { Currency } from "../../../../js/common/CurrencyFormatter";
import ProductPriceWatchdogSubmitted from "./ProductPriceWatchdogSubmitted";
import ProductPriceWatchdogForm from "./ProductPriceWatchdogForm";

interface ProductPriceWatchdogModalProperties {
    readonly productDetailInfo: ProductDetailInfo;
    readonly currency: Currency;
}

export default function ProductPriceWatchdogModal({ productDetailInfo, currency }: ProductPriceWatchdogModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [submittedData, setSubmittedData] = React.useState({ agree: false, price: 0, email: "" });

    const showModal = (): void => {
        setModalIsOpen(true);
    };

    const closeModal = (): void => {
        setModalIsOpen(false);
    };

    return (
        <>
            <div onClick={showModal}>
                <div className="product-attributes-summary-item-icon"><i className="fa-solid fa-dog"></i></div>
                Hlídat cenu
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="modal-dialog modal-transition"
                overlayClassName="react-modal-backdrop modal-transition shop-modal-change"
                closeTimeoutMS={150}
            >
                <div className="modal-content">
                    <div className="modal-header empty modal-header-image">
                        <button type="button" className="close" onClick={closeModal}>
                            <i className="fa-solid fa-times"></i>
                        </button>
                    </div>

                    {isSubmitted
                        ? <ProductPriceWatchdogSubmitted submittedData={submittedData} onClose={closeModal} currency={currency} />
                        : <ProductPriceWatchdogForm
                            productDetailInfo={productDetailInfo}
                            onSubmitted={(data): void => {
                                setIsSubmitted(true);
                                setSubmittedData(data);
                            }} />}
                </div>
            </Modal>
        </>
    );
}
